import { AfterViewInit, Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AbstractBaseComponent } from 'src/app/model/AbstractBaseComponent';
@Component({
  selector: 'app-header-inner',
  templateUrl: './header-inner.component.html',
})
export class HeaderInnerComponent
  extends AbstractBaseComponent
  implements AfterViewInit, OnInit, OnDestroy {
  ngOnInit(): void {
    super.ngOnInit();
  }

  ngOnDestroy(): void {
    super.ngOnDestroy();
  }

  ngAfterViewInit(): void {
    super.ngAfterViewInit();
  }

  constructor(public router: Router) {
    super();
  }

  goToProfilo() {
    this.router.navigate(['/a-profilo/modifica']);
  }

  goToProfiloStudente() {
    this.router.navigate(['/modifica-profilo']);
  }

  logout() {
    sessionStorage.clear();
    localStorage.clear();
    this.router.navigate(['/login']);
  }
}
